
angular.module('mtic.components.navbar')
.directive('navBarMyClasses', function (TeacherDataService, language, EventManager,userAccount,$q, notificationService, MapStateService) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navbar:my-classes:click');
      var isUpdating = false;
      var active_slug = '';

      function onClick(){
        eventManager.broadcast("navbar:my-classes:click");
        if(active_slug){
          eventManager.broadcast('module:close:resource');
        }
        isUpdating = false;
      }


      eventManager.listen('agenda_myclasses_change_request_granted', function(e, args){
        scope.clickButton(true);
      })

      scope.getTranslation = function(slug){
        return language.get(slug);
      }

      scope.clickButton = function(dont_stop){
        if(notificationService.isNotificationActive()){
          return;
        }else{
          notificationService.hideNotifications();
        }
        if(TeacherDataService.inTeacherAgendaView && !dont_stop){
          eventManager.broadcast('request_agenda_change', {goto_myclass: true});
          return;
        }

        MapStateService.setFocusSlug("");

        if(isUpdating){
          return;
        }

        isUpdating = true;
        if(active_slug && active_slug.indexOf('_m56_') > -1 &&!userAccount.getData().role.isTeacher){
          var defer = $q.defer();
          eventManager.broadcast("module:updateAndClose:resource",defer);
          defer.promise.then(onClick,function(){
            isUpdating = false;
          });
        }else{
          onClick();
        }
      }

      eventManager.listen('module:open:resource', function(e, data){
        active_slug = data.slug;
      });

      eventManager.listen('module:close:resource', function(e, data){
        active_slug = "";
      });
    }
  }
})
